import React from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";

// styles
import styles from "./AdvertismentSlider.module.scss";

// data
import { advertismentSlider } from "src/utils/data";

SwiperCore.use([Pagination, Navigation, Autoplay]);

const AdvertismentSlider = () => {
  return (
    <div className={styles.home__slider__wrapper}>
      <Swiper
        navigation={false}
        centeredSlides={true}
        freeMode={true}
        slidesPerView="auto"
        preloadImages
        pagination={{
          clickable: true,
          type: "bullets",
          bulletActiveClass: styles.bullet_active,
          bulletClass: styles.bullet,
        }}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        loop={true}
      >
        {advertismentSlider.map((item, i) => (
          <SwiperSlide key={i}>
            <img src={item} alt="event_details" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default AdvertismentSlider;
